module.exports = __webpack_public_path__ + "static/media/gallery.f41622aa.svg";